import { AsyncPageRender } from '@components/AsyncComponent';
import { ProtectedRoute } from '@components/Layout/ProtectedRoute';
import { pageModule } from '@components/pageModule';
import { Route } from '@packages/router';
import React from 'react';

export const routes$ = {
    Review: AsyncPageRender(() => pageModule(import('./views/Review'))),
};

function Router() {
    return (
        <>
            <Route
                name={'MyCart.Review'}
                exact
                path={'/my-cart/review'}
                component={ProtectedRoute(routes$.Review, { required: null })}
            />
        </>
    );
}

export default Router;
